


import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { ASSIGN_MENU_BY_ROLE, CREATE_MENU_URl,  DELETE_MENU_URl, GET_MENU_BY_ROLE_URl, GET_MENU_URl, GET_PARENT_MENU_URl, UPDATE_MENU_URl, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetParentMenu = createAsyncThunk('allparentMenu', async (_, { rejectWithValue }) => {

    try {
        await new Promise(resolve => setTimeout(resolve, 800));
        const response = await FetchData(GET_PARENT_MENU_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllParentMenuSlice = createSlice({
    name: 'Parent Menu',
    initialState: {
        ParentMenu: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetParentMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetParentMenu.fulfilled, (state, action) => {
                state.ParentMenu = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetParentMenu.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


// -- Async Thunk to Get User Profile --
export const GetAllMenu = createAsyncThunk('allMenu', async (_, { rejectWithValue }) => {

    try {
        const response = await FetchData(GET_MENU_URl, {});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {

            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- GetAllMenuSlice --
const GetAllMenuSlice = createSlice({
    name: 'User',
    initialState: {
        Menu: {},
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllMenu.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllMenu.fulfilled, (state, action) => {
                state.Menu = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllMenu.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const GetSingleMenuSlice = createSlice({
    name: 'Single Menu ',
    initialState: {
        Menu: ''
    },
    reducers: {
        setMenuItem: (state, action) => {
            state.Menu = action.payload;
        }
    }
});

export const CreateMenue = createAsyncThunk('Addmenu', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_MENU_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Menu Created successfully.')
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateMenu = createAsyncThunk('updatemenu', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_MENU_URl, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', 'Menu updated successfully.')

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteMenuItem = createAsyncThunk('deletMenu', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_MENU_URl, {MenuMasterID : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
           Toast('success', 'Menu Deleted successfully.')

           return 'ok' 
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});



// -- Assign Menu By User-
export const AssignMenuByUser = createAsyncThunk('assignMenu', async (body, { rejectWithValue }) => {
    try {
        const response = await FetchData(ASSIGN_MENU_BY_ROLE, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)

            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// Check Assign Menu ---------
export const CheckAssignMenu = createAsyncThunk('checkAssignMenu', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(GET_MENU_BY_ROLE_URl, {RoleID : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            const { data } = response?.data
            return {status : 200, data}
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const {setMenuItem} = GetSingleMenuSlice.actions
export {
    GetAllMenuSlice,
    GetAllParentMenuSlice,
    GetSingleMenuSlice
};
